/**
 * Trigger a browser download for in-memory content. Used for CSV / GeoJSON
 * exports across the app. Identical to the helper that used to live in
 * `Layers.tsx` and `Coords.tsx`; this module is the single source.
 *
 * A `Blob` is passed straight through — the strip map's PNG is composed as one
 * (`stationVolumes/stripPng.ts`) and wrapping it in another `Blob` would
 * stringify the binary to "[object Blob]". `mime` is then the blob's own and
 * this argument is ignored.
 */
export function downloadFile(content: string | Blob, filename: string, mime = 'application/json'): void {
  const blob = content instanceof Blob ? content : new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
